import { FORM_BUILDER_FIELD_TYPE, formBuilderMapper, ButtonSizeOptions } from "@loanbossinc/component-library";
import shortid from "shortid";
import { remove } from "lodash";

import { shouldShowRateReductionTerms } from "./section-loan-misc-rows-logic";

export const rows = (getCompanyContacts, configItems) => ({
  title: {
    isTitle: true,
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Miscellaneous",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "14px",
          textTransform: "uppercase",
          color: "#000000",
          marginBottom: "10px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.miscellaneous.header"
      }
    ]
  },
  loanProvider: {
    hasNestedRows: true,
    key: "details.loanProvider",
    label: "Lender",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NESTED,
        Cell: formBuilderMapper,
        style: { width: "100%" },
        subComponents: [
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
              label: "Lender",
              key: `loanCompanyBridgeid-${index}`,
              name: `details.loanProvider[${index}].loanCompanyBridge.companyId`,
              componentorder: 0,
              collectionname: "lenders",
              variant: "filled",
              displayWith: option => option.name,
              setValueWith: option => option.id,
              onChange: (value, formik) => {
                const loan = formik.values;
                loan.details.loanProvider[index].loanCompanyBridge.companyId = value;
                configItems.loanProviderContacts[index] = getCompanyContacts(loan, value, "lenders");
                loan.details.loanProvider[index].loanCompanyBridge.companyContactId = null;
                loan.details.loanProvider[index].loanCompanyBridge.lenderTypeId = null;
                formik.setValues({ ...formik.values, loan });
              }
            })
          },

          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.BUTTON,
              label: "Remove Lender",
              hasBorder: false,
              size: ButtonSizeOptions.smFluid,
              name: `details.loanProvider[${index}].loanCompanyBridge.id`,
              style: { width: "214px", marginTop: "10px", float: "right", border: "none" },
              onClick: (value, formik) => {
                if (value) {
                  const values = formik.values;
                  values.details.loanProvider = remove(values.details.loanProvider, item => item.loanCompanyBridge.id !== value);
                  formik.handleChange();
                  formik.handleBlur();
                }
              }
            })
          },

          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
              label: "Lender Type",
              key: `loanCompanyBridgeid-${index}`,
              name: `details.loanProvider[${index}].loanCompanyBridge.lenderTypeId`,
              collectionname: "lenderTypes",
              variant: "filled",
              displayWith: option => option.name,
              setValueWith: option => option.id,
              style: { marginTop: "10px", marginLeft: "0", paddingRight: "230px" }
            })
          },

          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
              label: "Allocation",
              name: `details.loanProvider[${index}].loanCompanyBridge.lenderAllocation`,
              variant: "filled",
              style: { marginTop: "10px", marginLeft: "0", width: "288px", paddingRight: "11px" }
            })
          },
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
              label: "Tag a contact",
              key: `loanCompanyBridgecompanyContactId-${index}`,
              name: `details.loanProvider[${index}].loanCompanyBridge.companyContactId`,
              componentorder: 1,
              collectionname: `loanProviderContacts[${index}]`,
              variant: "filled",
              displayWith: option => option.name,
              setValueWith: option => option.id,
              hideLabel: true,
              style: { marginTop: "10px", marginLeft: "0", paddingRight: "230px", marginBottom: "10px" }
            })
          },
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.SWITCH,
              label: "Lead",
              name: `details.loanProvider[${index}].loanCompanyBridge.isLead`
            })
          }
        ]
      }
    ]
  },
  addLenderRecord: {
    key: "addLenderRecord",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "LENDER"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.BUTTON_PRIMARY,
        label: "Add Lender",
        hideLabel: true,
        size: ButtonSizeOptions.lgFluid,
        onClick: (value, formik) => {
          const values = formik.values;
          const newItem = {
            id: null,
            name: null,
            loanCompanyBridge: {
              id: `NEW-${shortid.generate()}`,
              loanId: null,
              companyId: null,
              lenderAllocation: null,
              isLead: false
            }
          };
          values.details.loanProvider.push(newItem);
          formik.handleChange();
          formik.handleBlur();
        },
        style: { width: "132px", marginTop: "10px", float: "right" }
      }
    ]
  },
  lendersCounsel: {
    label: "Lenders Counsel",
    cells: [
      {
        style: { width: "285px", marginTop: "10px" },
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "details.lenderCounselCompanyId",
        variant: "filled",
        key: "lenderCounsel",
        label: "Select a company",
        parentId: "lenderCounsels",
        hideLabel: true,
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: (value, formik) => {
          const loan = formik.values;
          loan.details.lenderCounselCompanyId = value;
          configItems.lendersCounselContact = getCompanyContacts(loan, value, "lenderCounsels");
          loan.details.lenderCounselContactId = null;
          formik.setValues({ ...formik.values, loan });
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "details.lenderCounselContactId",
        parentId: "lendersCounselContact",
        label: "Tag a contact",
        hideLabel: true,
        displayWith: option => option.name,
        setValueWith: option => option.id,
        variant: "filled",
        style: { marginLeft: "16px" }
      }
    ]
  },
  servicerCompany: {
    label: "Servicer",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "details.servicerCompanyId",
        key: "servicerCompanyId",
        variant: "filled",
        parentId: "servicers",
        options: [],
        displayWith: option => option.name,
        setValueWith: option => option.id,
      }
    ]
  },
  loanReferenceNumber: {
    label: "Loan Reference Number",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "details.loanReferenceNumber",
        variant: "filled"
      }
    ]
  },
  borrower: {
    label: "Borrower",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "details.counterparty",
        variant: "filled",
        multiline: true
      }
    ]
  },
  borrowerCounselCompany: {
    label: "Borrowers Counsel",
    cells: [
      {
        style: { width: "285px", marginTop: "10px" },
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "details.borrowerCounselCompanyId",
        variant: "filled",
        key: "borrowerCounselCompany",
        parentId: "borrowerCounsels",
        label: "Select a company",
        hideLabel: true,
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: (value, formik) => {
          const loan = formik.values;
          loan.details.borrowerCounselCompanyId = value;
          configItems.borrowerCounselContacts = getCompanyContacts(loan, value, "borrowerCounsels");
          loan.details.borrowerCounselContactId = null;
          formik.setValues({ ...formik.values, loan });
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "details.borrowerCounselContactId",
        key: "borrowerCounselContact",
        parentId: "borrowerCounselContacts",
        label: "Tag a contact",
        hideLabel: true,
        displayWith: option => option.name,
        setValueWith: option => option.id,
        variant: "filled",
        style: { marginLeft: "16px" }
      }
    ]
  },
  titleCompany: {
    label: "Title Company",
    cells: [
      {
        style: { width: "285px", marginTop: "10px" },
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "details.titleCompanyId",
        key: "titleCompany",
        variant: "filled",
        label: "Select a company",
        parentId: "titleCompany",
        hideLabel: true,
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: (value, formik) => {
          const loan = formik.values;
          loan.details.titleCompanyId = value;
          configItems.titleCompanyContacts = getCompanyContacts(loan, value, "titleCompany");
          loan.details.titleCompanyContactId = null;
          formik.setValues({ ...formik.values, loan });
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "details.titleCompanyContactId",
        key: "titleCompanyContact",
        parentId: "titleCompanyContacts",
        variant: "filled",
        label: "Tag a contact",
        hideLabel: true,
        displayWith: option => option.name,
        setValueWith: option => option.id,
        style: { marginLeft: "16px" }
      }
    ]
  },
  loanSeniority: {
    label: "Loan Seniority",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "details.loanSeniorityId",
        variant: "filled",
        key: "loanSeniorityId",
        parentId: "loanSenorityTypes",
        displayWith: option => option.name,
        setValueWith: option => option.id,
      }
    ]
  },
  lienPriority: {
    label: "Lien Priority",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "details.lienPriority",
        variant: "filled"
      }
    ]
  },
  loanStatus: {
    label: "Loan Status",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "details.loanStatusId",
        variant: "filled",
        key: "loanStatusId",
        parentId: "loanStatuses",
        displayWith: option => option.name,
        setValueWith: option => option.id,
      }
    ]
  },
  loanType: {
    label: "Loan Type",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "details.loanTypeId",
        variant: "filled",
        key: "loanTypeId",
        parentId: "loanTypes",
        displayWith: option => option.name,
        setValueWith: option => option.id,
      }
    ]
  },
  rateReductionTerms: {
    isVisible: loan => shouldShowRateReductionTerms(loan),
    label: "Rate Reduction Terms",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "details.rateReductionTerms",
        variant: "filled"
      }
    ]
  },
  defaultInterestSpread: {
    label: "Default Interest Spread",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: "details.defaultInterestSpread",
        variant: "filled",
        decimals: 3
      }
    ]
  },
  recurringCosts: {
    label: "Recurring Costs",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "details.recurringCosts",
        variant: "filled",
        multiline: true
      }
    ]
  },
  additionalInterest: {
    label: "Additional Interest",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "details.additionalInterest",
        variant: "filled",
        multiline: true
      }
    ]
  },
  collateralization: {
    label: "Collateralization",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "details.collateralization",
        variant: "filled",
        multiline: true
      }
    ]
  },
  loanRiskRating: {
    label: "Loan Risk Rating",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "details.loanRiskRatingId",
        variant: "filled",
        key: "loanRiskRatingId",
        parentId: "loanRiskRatingTypes",
        displayWith: option => option.name,
        setValueWith: option => option.id
      }
    ]
  },
  footnote: {
    label: "Footnotes",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.RICH_TEXT,
        name: "details.footnote",
        variant: "filled",
        multiline: true
      }
    ]
  }
});
